import type { SimpleKeyboard } from 'react-simple-keyboard';

import { getWritableInputTypesConfig } from '../utils/KeyUtils';

const specialTypes = (keyboard: SimpleKeyboard) => {
  keyboard.registerModule('specialTypes', () => {
    const { language, type } = keyboard.getOptions();
    const config = getWritableInputTypesConfig(language)[type];
    if (config?.layout) {
      keyboard.setOptions({
        layoutName: 'default',
        enableLayoutCandidates: false,
        layout: config.layout,
      });
    }
  });
};
export default specialTypes;
